import { Component, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables/src/angular-datatables.directive';
import { Subject } from 'rxjs/internal/Subject';
import { SessionService } from '../Util/Session/session.service';
import { ComboService } from '../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { UtilityService } from '../Model/utility/utility.service';
import { CommonService } from '../Model/Common/common.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { ReimbursementformService } from '../Model/Reimbursement/reimbursementform.service';
import { NgbDateParserFormatter, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';

@Component({
  selector: 'app-non-ctc-claim-form',
  standalone: true,
  imports: [FormsModule, LoaderComponent, CommonModule, NgSelectModule, NgbModule, DataTablesModule],
  providers: [
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
      ],
  templateUrl: './non-ctc-claim-form.component.html',
  styleUrl: './non-ctc-claim-form.component.scss'
})
export class NonCtcClaimFormComponent {
  isDisabled: boolean = false;
  ReimbursementLoad: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  ReimbursementHistory: any[] = [];
  Reimbursement = {
    SelectType: '0',
    Remark: null,
    ESS_ReimbursementRequestId: null,
    ESS_ReimbursementTypeId: null as any,
    OutstandingAmount: 0,
    BillAmount: null as any,
    ClaimedAmount: null as any,
    MonthYear: '',
    selectedMonth: '',
    selectedYear: '',
    Attachment: '',
    EmpMasterId: null as any,
    ApprovalStatus: '',
    BillDate: null as any,
    BillFromDate: null as any,
    BillToDate: null as any,
    IsNonCTC_Claim: true
  };
  selectedMonth: any = null
  Filter = {
    Type: 'Request',
  }

  selectedFile: File | null = null;
  ImageUrl: any;
  public User: any = null;
  dtoptions: DataTables.Settings = {};
  constructor(private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private utility: UtilityService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private reimbursement: ReimbursementformService,
    private modalService: NgbModal,
    private router: Router,
    private format: CustomDateParserFormatter
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }
  ngOnInit(): void {
    this.Reimbursement.EmpMasterId = this.sessionService.GetUserDetails().UserId;
    this.ComboLoad('ReimbursementType_NonCTC');
    // this.ComboLoad('OpenMonthYear');
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  Validate(form: any) {
    if (form.valid) {
      this.ESS_ReimbursementRequest_Insert();
    }
    else {
      form.submitted = true;
    }
  }
  async ESS_ReimbursementRequest_Insert() {
    await this.common.getPageRights();
    if (this.Reimbursement.BillAmount === null || this.Reimbursement.BillAmount < 0) {
      this.toast.show({ message: 'Bill Amount must be greater than 0.', type: toastTypeEnum.warning });
      return;
    }
    if (this.Reimbursement.ClaimedAmount === null || this.Reimbursement.ClaimedAmount <= 0) {
      this.toast.show({ message: 'Claimed Amount must be greater than 0.', type: toastTypeEnum.warning });
      return;
    }
    // if (this.Reimbursement.OutstandingAmount === null || this.Reimbursement.ClaimedAmount > this.Reimbursement.OutstandingAmount) {
    //   this.toast.show({ message: 'Claimed Amount cannot be greater than Outstanding Amount.', type: toastTypeEnum.warning });
    //   return;
    // }
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.Reimbursement.SelectType = 'insert'
        this.Reimbursement.BillDate = this.format.format(this.Reimbursement.BillDate);
        this.Reimbursement.BillFromDate = this.format.format(this.Reimbursement.BillFromDate);
        this.Reimbursement.BillToDate = this.format.format(this.Reimbursement.BillToDate);
        console.log(this.reimbursement);
        this.reimbursement.ESS_ReimbursementRequest_Insert(this.Reimbursement).subscribe({
          next: (response) => {

            if (response.Error_Code == '498' || response.Error_Code == '499') {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  // window.location.reload();
                  this.close();
                }
              });
            }
            else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }
  onFileSelected(event: any) {
    this.isDisabled = true
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
    if (this.selectedFile) {
      this.uploadToFTP(this.selectedFile);
    } else {
      this.isDisabled = false;
    }
  }
  removeFile() {
    this.selectedFile = null;
    this.Reimbursement.Attachment = '';
    const fileInput = document.getElementById('formFileSm') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  viewFile() {
    window.open(this.ImageUrl, '_blank');
  }
  uploadToFTP(file: File) {
    if (!file) {
      return;
    }
    this.isDisabled = true
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.utility.Upload({ 'DomainName': this.User.Domain, 'folder': 'Reimbursement', 'CompanyCode': this.User.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
        if (response.FileName != "") {
          this.Reimbursement.Attachment = response.FileName;
          this.ImageUrl = response.Url;
          this.isDisabled = false
        } else {
          this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      }, (error) => {
        console.error('FTP Upload Error:', error);
        this.isDisabled = false;
      });
    };
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'EmpMasterID': this.Reimbursement.EmpMasterId
      //'BranchId': (Combotype == 'ReimbursementType') ? this.Reimbursement.ReimbursementId : 0,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'ReimbursementType_NonCTC') {
          this.ReimbursementLoad = response.ComboLoad;
          this.isDisabled = false
        }
        else if (Combotype == 'OpenMonthYear') {
          this.Reimbursement.MonthYear = response.ComboLoad[0].MonthYear;
          const [month, year] = this.Reimbursement.MonthYear.split(' ');
          this.Reimbursement.selectedMonth = month;
          this.Reimbursement.selectedYear = year;
          this.isDisabled = false;
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  onSelectChange(type: string) {
    if (type === 'ReimbursementType') {
      this.ReimbursementHistory = []
      this.isDisabled = true
      this.Reimbursement.SelectType = '2';
      this.reimbursement.ESS_ReimbursementRequest_Load(this.Reimbursement).subscribe({
        next: (data) => {
          if (data && data.Table.length > 0) {
            this.Reimbursement.OutstandingAmount = data.Table[0].OutstandingAmount;
            this.isDisabled = false
          }
          else {
            this.Reimbursement.OutstandingAmount = 0;
            this.isDisabled = false
          }
        },
        complete: () => {
          this.isDisabled = false
        },
        error: (error) => {
          this.isDisabled = false
          console.error('Error:', error);
        },
      });
    }
  }
  FilterBy(type: string) {
    this.Filter.Type = type;
    this.ReimbursementHistory = []
  }
  Apply() {
    this.ESS_LoadReimbursement();
  }
  ESS_LoadReimbursement() {
    if (this.Reimbursement.ESS_ReimbursementTypeId === null || this.Reimbursement.ESS_ReimbursementTypeId === '') {
      this.toast.show({ message: 'Please select Reimbursement.', type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true;
    this.Reimbursement.SelectType = 'S';
    this.reimbursement.ESS_LoadReimbursementHistory(this.Reimbursement).subscribe({
      next: (data) => {
        this.ReimbursementHistory = data.Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  getHeaders() {
    return this.ReimbursementHistory.length > 0
      ? Object.keys(this.ReimbursementHistory[0]).filter(key => key !== 'Particulars')
      : [];
  }
  close() {
    this.router.navigate(['/request/reimbursement/nonctc']);
  }

  validate(event: KeyboardEvent, type: string) {
    if (type === 'billamount') {
      const inputValue = event.key;
      if (!/^[0-9.]$/.test(inputValue)) {
        event.preventDefault();
        return;
      }
      const currentValue = this.Reimbursement.BillAmount;
      if (inputValue === '.') {
        if (currentValue.includes('.')) {
          event.preventDefault();
        }
      }
    } else if (type === 'claimamount') {
      const inputValue = event.key;
      if (!/^[0-9.]$/.test(inputValue)) {
        event.preventDefault();
        return;
      }
      const currentValue = this.Reimbursement.ClaimedAmount;
      if (inputValue === '.') {
        if (currentValue.includes('.')) {
          event.preventDefault();
        }
      }
    }

  }


  // onNavigate() {
  //   this.Reimbursement.MonthYear = this.selectedMonth.month +' ' + this.selectedMonth.year
  //   console.log('cdsf',this.Reimbursement.MonthYear);
  // }

  onNavigate() {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthName = monthNames[this.selectedMonth.month - 1];
    this.Reimbursement.MonthYear = monthName + ' ' + this.selectedMonth.year;
  }

}
